import { Component, Injector, OnInit, OnDestroy, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataTableColumn } from 'src/app/_models/messaging/datatable-column';
import { MessageReportsService } from 'src/app/_services/messaging/messages/message-reports.service';
import { DetailedEmailReportRequest } from 'src/app/_models/messaging/messages/message-reports/detailed-reports/detailed-email-report-request'
import { DateService } from 'src/app/_services/system/date.service';
import { Location } from '@angular/common';
import { PagerDtoRequest } from 'src/app/_models/messaging/pager-dto-request';
import { ExecutionResultDto } from 'src/app/_models/execution-result-model';
import { ExecutionResult } from 'src/app/_models/execution-result-enum';
import { NotificationService } from 'src/app/_services/notification.service';
import * as moment from 'moment';
import { HelperService } from 'src/app/_services/system/helpers/helper.service';
import { MessageTypeEnum } from 'src/app/_models/messaging/messages/message-type-enum';
import { LoadingSpinnerService } from 'src/app/_services/loading-spinner/loading-spinner.service';
import { MessagingAbstract } from 'src/app/_models/messaging/messaging-abstract';
import { UnsubscribeService } from 'src/app/_services/system/unsubscribe.service';
import { Subscription } from 'rxjs';
import { DataTypesEnum } from 'src/app/_models/selected-fields-filters/data-types-enum';
import { TableActionType, TableName } from 'src/app/views/shared/constants/table-constants';

@Component({
  selector: 'app-message-report-details-filtered',
  templateUrl: './message-report-details-filtered.component.html',
  styleUrls: ['./message-report-details-filtered.component.scss']
})
export class MessageReportDetailsFilteredComponent extends MessagingAbstract implements OnInit, AfterViewInit, OnDestroy {

  filterRules = '';
  title = "";
  backUrl;
  getReportSubscription: Subscription;
  getReportFieldsSubscription: Subscription;
  dataType = DataTypesEnum.EmailDetailedReport;
  _reportID: number;
  _messageTypeEnum: MessageTypeEnum;
  _filter: string;
  _pageTitle = '';
  _exportCancelled = false;
  _exporting = false;
  _exportPercent = 0;
  _exportMessage = '';
  _exportRows: { [prop: string]: any }[] = [];
  _sortColumn: string = 'MessageID';
  _sortDirection: string = 'Descending';
  _pageLimit = 1000;
  _page = 1;
  _columns: DataTableColumn[] = [];


  constructor(
    public activatedRoute: ActivatedRoute,
    public messageReportsService: MessageReportsService,
    public dateService: DateService,
    public location: Location,
    public notificationService: NotificationService,
    public helperService: HelperService,
    public loadingSpinnerService: LoadingSpinnerService,
    injector: Injector,
    private cdr: ChangeDetectorRef
  ) {
   super(injector);
  this.tableKey = 'emailDetailedReport'
  this.init();
  }

  ngOnInit(): void {

    if (this.paginationDataService.getFilterRules()) {
      this.filterRules = this.paginationDataService.getFilterRules();
    }

    this.paginationDataService.GetChildPaginationDataFromLocalStorage();
    this.paginationDataService.GetFolderIdFromLocalStorage();
    this.paginationDataService.GetListIdFromLocalStorage();

    this.activatedRoute.params.subscribe(params => {
      this._reportID = params.reportID;
      this._filter = params.filter;
      
      if (this._filter.toLowerCase().indexOf('email') > -1) {
        this._messageTypeEnum = MessageTypeEnum.email;
        this.title = "Email Reports";
      } else if (this._filter.toLowerCase().indexOf('rcs') > -1) {
        // Determine specific RCS type based on filter
        const filterLower = this._filter.toLowerCase();
        if (filterLower.indexOf('carousel') > -1) {
          this._messageTypeEnum = MessageTypeEnum['rcs-carousel'];
        } else if (filterLower.indexOf('richcard') > -1 || filterLower.indexOf('rich-card') > -1) {
          this._messageTypeEnum = MessageTypeEnum['rcs-rich-card'];
        } else {
          this._messageTypeEnum = MessageTypeEnum['rcs-text'];
        }
        this.title = "RCS Reports";
      } else {
        this._messageTypeEnum = MessageTypeEnum.sms;
        this.title = "SMS Reports";
      }
    });

   let filteredInput = this._filter.replace(/Total/g, '');
   const words = filteredInput.replace(/([A-Z]+)/g, ' $1').trim().split(' ').filter(word => word);
   this.tableName = `Total ${words.join(' ')}`;

    setTimeout(() => {
      this.tableService.requestTableData(true);
    }, 0);

    this.backUrl = this.router.url.split('/').slice(0, -1).join('/');
  }

  actionHandler({ selectedRows, action, extraOptions }): void {
    switch (TableActionType[action]) {
      case TableActionType.export:
        this.export(selectedRows);
        break;
    }
  }

  ngAfterViewInit(): void {
     this.paginationDataService.SetChildPaginationDataToLocalStorage(
       this._page, this._pageLimit, this.sortColumn, this.sortDirection, this.tableName);
  }

  getDetailedReport(data?): void {
    this.loadingSpinnerService.loading();
    this.filterRules = data.filters;
    this.paginationDataService.setFilterRules(this.filterRules);
    this._sortColumn = data.sortColumn ?? this._sortColumn;
    this._sortDirection = data.sortDirection ?? this._sortDirection;

    const pagerDtoRequest = new PagerDtoRequest({
      page: data.currentPage,
      pageSize: data.pageLimit,
      sortColumn: data.sortColumn,
      sortDirection: data.sortDirection
    });

    const getDetailedEmailReportRequest = new DetailedEmailReportRequest({
      reportId: this._reportID,
      filter:  this.filterRules,
      emailFilter:  this._filter,
      pagerDtoRequest
    });

    this.getReportSubscription = this.messageReportsService.getDetailedReportData(getDetailedEmailReportRequest, this._messageTypeEnum)
      .subscribe({
        next: (executionResultDto: ExecutionResultDto) => {

          if (executionResultDto.executionResult === ExecutionResult.success) {
            this.displayedColumns = executionResultDto.data.Columns.map((column, i) => {
              if (executionResultDto.data.Columns.length >= i + 1) {
                return {
                  name: column.Name,
                  displayName: column.DisplayName.replace(/([a-z])([A-Z])/g, '$1 $2')
                };
              }
            });

            this.data = this.getRows(executionResultDto.data.Records);
            this.length = executionResultDto.data.Total;
          } else {
            this.notificationService.showError(executionResultDto.message);
          }
          this.loadingSpinnerService.stopLoading();
        },
        error: () => {
          this.loadingSpinnerService.stopLoading();
        }
      });
  }

  export(columns: string[]) {
    const total = this.length;
    if (!total || total < 1) {
      this.notificationService.showWarning('No data to export.');
      return;
    }

    const safeColumns = (columns ?? []).filter((c) => c && String(c).trim().length > 0);
    if (safeColumns.length < 1) {
      this.notificationService.showWarning('Select at least one column to export.');
      return;
    }

    if (!this.displayedColumns?.length) {
      this.notificationService.showWarning('Table columns are not loaded yet. Please wait and try again.');
      return;
    }

    if (this._exporting) {
      this.notificationService.showWarning('An export is already in progress.');
      return;
    }

    this._exportCancelled = false;
    this._exporting = true;
    this._exportPercent = 0;
    this._exportMessage = 'About 0% loaded';
    this.cdr.detectChanges();

    const chunkSize = 5000;
    const totalChunkRequests = Math.max(1, Math.ceil(total / chunkSize));
    const maxPages = totalChunkRequests + 50;
    const allRecords: any[] = [];
    let page = 1;

    const refreshExportProgress = () => {
      const loaded = allRecords.length;
      let pct = 0;
      if (total > 0 && loaded > 0) {
        pct = Math.ceil((loaded / total) * 100);
        if (loaded < total) {
          pct = Math.min(99, Math.max(1, pct));
        } else {
          pct = 100;
        }
      }
      this._exportPercent = pct;
      this._exportMessage = `About ${pct}% loaded`;
      this.cdr.detectChanges();
    };

    const finishExport = (onFinally?: () => void) => {
      this._exporting = false;
      this._exportPercent = 0;
      this._exportMessage = '';
      this.cdr.detectChanges();
      onFinally?.();
    };

    const writeCsv = (rowsRaw: any[]) => {
      const rows = rowsRaw.length > total ? rowsRaw.slice(0, total) : rowsRaw;
      const today = new Date();
      const fileName = `${this.tableName}_${today.getDate()}${today.getMonth() + 1}${today.getFullYear()}`;
      this._exportRows = this.getRowsForExport(rows, safeColumns);
      this.helperService.exportToCSV(fileName, this._exportRows);
    };

    const tryWriteCsvAndFinish = (rowsRaw: any[], onFinally?: () => void) => {
      try {
        writeCsv(rowsRaw);
        finishExport(onFinally);
      } catch {
        finishExport(() =>
          this.notificationService.showError('Could not build or download the CSV file. Please try again.')
        );
      }
    };

    const fetchNext = () => {
      if (this._exportCancelled) {
        finishExport();
        return;
      }

      if (page > maxPages) {
        if (allRecords.length > 0) {
          tryWriteCsvAndFinish(allRecords, () =>
            this.notificationService.showWarning(
              `Export stopped after ${maxPages} page requests. Saved ${allRecords.length.toLocaleString()} rows (total was ${total.toLocaleString()}).`
            )
          );
        } else {
          finishExport(() =>
            this.notificationService.showError(
              'Export stopped: too many empty pages. Try again or contact support.'
            )
          );
        }
        return;
      }

      const pagerDtoRequest = new PagerDtoRequest({
        page,
        pageSize: chunkSize,
        sortColumn: this._sortColumn,
        sortDirection: this._sortDirection
      });

      const getDetailedEmailReportRequest = new DetailedEmailReportRequest({
        pagerDtoRequest,
        reportId: this._reportID,
        filter: this.filterRules ?? '',
        emailFilter: this._filter
      });

      this.messageReportsService.getDetailedReportData(getDetailedEmailReportRequest, this._messageTypeEnum)
        .subscribe({
          next: (executionResultDto: ExecutionResultDto) => {
            if (this._exportCancelled) {
              finishExport();
              return;
            }

            if (executionResultDto.executionResult !== ExecutionResult.success) {
              finishExport(() =>
                this.notificationService.showError(executionResultDto.message || 'The export request failed.')
              );
              return;
            }

            if (!executionResultDto.data) {
              finishExport(() => this.notificationService.showError('Invalid response from server.'));
              return;
            }

            const recs = executionResultDto.data.Records ?? [];
            allRecords.push(...recs);

            refreshExportProgress();

            if (allRecords.length >= total) {
              this._exportPercent = 100;
              this._exportMessage = 'About 100% — preparing download';
              this.cdr.detectChanges();
              tryWriteCsvAndFinish(allRecords);
              return;
            }

            if (recs.length === 0) {
              if (allRecords.length === 0) {
                finishExport(() => this.notificationService.showError('No rows returned for export.'));
              } else {
                tryWriteCsvAndFinish(allRecords, () => {
                  if (allRecords.length < total) {
                    this.notificationService.showWarning(
                      `Exported ${allRecords.length.toLocaleString()} rows; the report total was ${total.toLocaleString()}.`
                    );
                  }
                });
              }
              return;
            }

            page += 1;
            fetchNext();
          },
          error: () => {
            finishExport(() => this.notificationService.showError('Could not export the report. Please try again.'));
          }
        });
    };

    fetchNext();
  }

  ngOnDestroy(): void {
    this._exportCancelled = true;
    this.loadingSpinnerService.stopLoading();
    UnsubscribeService.unsubscribe(
      this.getReportSubscription,
      this.getReportFieldsSubscription
    );
  }

  isDate(value) {
    return moment(value.toString().substring(0, 10), 'YYYY-MM-DD', true).isValid();
  }

  getRows(records: any) {
    let rows: { [prop: string]: any }[] = [];
    rows = records.map(record => {
      const row: { [prop: string]: any } = {};
      Object.keys(record).map(key => {
        if (record[key] !== null && record[key] !== undefined) {
          if (this.isDate(record[key])) {
            row[key] = this.dateService.formatStringDate(record[key]);
          } else if (record[key].toString().toLowerCase() === 'true') {
            row[key] = 'Yes';
          } else if (record[key].toString().toLowerCase() === 'false') {
            row[key] = 'No';
          } else {
            row[key] = record[key];
          }
        }
      });
      return row;
    });
    return rows;
  }

  getRowsForExport(records: any, columns: string[]) {
    let rows: { [prop: string]: any }[] = [];
    const columnsToExport = this.displayedColumns.filter((column) => columns.find((col) => col === column.displayName));

    rows = records.map(record => {
      const row: { [prop: string]: any } = {};
      Object.keys(record).map(key => {
        var friendlyName = key.replace(/([a-z])([A-Z])/g, '$1 $2');
        if (columnsToExport.some(col => col.displayName === friendlyName)) {
          if (friendlyName.indexOf(',') != -1) friendlyName = friendlyName.replace(/,/g, ''); //remove commas from column names if they are any
          if (record[key] !== null && record[key] !== undefined) {
            if (this.isDate(record[key])) {
              row[friendlyName] = this.dateService.formatStringDate(record[key]);
            } else if (record[key].toString().toLowerCase() === 'true') {
              row[friendlyName] = 'Yes';
            } else if (record[key].toString().toLowerCase() === 'false') {
              row[friendlyName] = 'No';
            } else {
              row[friendlyName] = record[key];
            }
          } else {
            row[friendlyName] = record[key];
          }
        }
      });
      return row;
    });
    return rows;
  }
}
